import { RewardListModel } from 'models/recruit/RewardListModel'
import Logger from 'utils/logging'
import { clientWithNoHeaders } from './client'

export default async function getRecruitmentRewards(
    userToken: string
): Promise<RewardListModel> {
    const rewards = await clientWithNoHeaders({
        url: '/rewards/me',
        method: 'get',
        headers: {
            Authorization: `Bearer ${userToken}`,
        },
    })
        .then((result) => {
            // console.log('Rewards api call list', result.data)
            return result && result.data
        })
        .catch((error) => {
            Logger.captureNetworkException(
                error,
                'rewards/me',
                'recruit.rewardsMe'
            )
            return ''
        })

    return rewards
}
